import { render, staticRenderFns } from "./FormTemplatePart.vue?vue&type=template&id=5dec5438&"
import script from "./FormTemplatePart.vue?vue&type=script&lang=js&"
export * from "./FormTemplatePart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports